import {
  PiSquaresFour,
  PiEnvelope,
  PiBellSlash,
  PiDotsThree,
} from "react-icons/pi";
import { IoChevronBack } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ProfileMenu from "./ProfileMenu";

const ModuleButton = ({ icon: Icon, label, size = "large" }) => {
  const isLarge = size === "large";

  return (
    <button
      className={`flex flex-col items-center ${isLarge ? "gap-3 p-4" : "gap-2 p-3"} hover:bg-gray-50 rounded-xl transition`}
    >
      <div
        className={`${isLarge ? "w-16 h-16" : "w-12 h-12"} bg-green-600 rounded-full flex items-center justify-center`}
      >
        <Icon className={`${isLarge ? "w-8 h-8" : "w-6 h-6"} text-white`} />
      </div>
      <span
        className={`${isLarge ? "text-sm" : "text-xs"} font-semibold text-gray-800 ${isLarge ? "" : "text-center"}`}
      >
        {label}
      </span>
    </button>
  );
};

const HeaderIcons = ({ userImage, userName = "User", onBack }) => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModulesOpen, setIsModulesOpen] = useState(false);

  return (
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-3 md:gap-4">
        {onBack && (
          <button
            onClick={onBack}
            className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center border-2 border-gray-300 rounded-xl hover:bg-gray-50 transition"
          >
            <IoChevronBack className="w-4 h-4 md:w-5 md:h-5 text-gray-600" />
          </button>
        )}
        <h1 className="font-[Poppins] font-medium text-xl md:text-2xl">
          {t("dashboard.title")}
        </h1>
      </div>

      {/* Desktop menu */}
      <div className="hidden md:flex items-center gap-2 border-2 border-gray-300 rounded-xl p-1.5 h-11 -ml-1">
        <div className="relative">
          <button
            onClick={() => setIsModulesOpen(!isModulesOpen)}
            className={`w-9 h-8 flex items-center justify-center border border-gray-300 rounded-lg transition ${isModulesOpen ? "bg-green-600 text-white border-green-600" : "hover:bg-gray-50"}`}
          >
            <PiSquaresFour className="w-5 h-5" />
          </button>

          {isModulesOpen && (
            <>
              <div
                className="fixed inset-0 z-40"
                onClick={() => setIsModulesOpen(false)}
              />
              <div className="absolute right-0 top-11 z-50 bg-white border-2 border-gray-300 rounded-2xl shadow-lg p-6 w-[240px] h-[300px]">
                <div className="grid grid-cols-2 gap-4">
                  <ModuleButton
                    icon={PiSquaresFour}
                    label={
                      <>
                        Ingredient
                        <br />
                        Library
                      </>
                    }
                    size="small"
                  />
                  <ModuleButton
                    icon={PiSquaresFour}
                    label={
                      <>
                        Recipe
                        <br />
                        Builder
                      </>
                    }
                    size="small"
                  />
                  <ModuleButton
                    icon={PiSquaresFour}
                    label={
                      <>
                        Product
                        <br />
                        Catalog
                      </>
                    }
                    size="small"
                  />
                  <ModuleButton
                    icon={PiSquaresFour}
                    label={
                      <>
                        Analytics
                        <br />
                        Hub
                      </>
                    }
                    size="small"
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <button className="w-9 h-8 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-50 transition">
          <PiEnvelope className="w-5 h-5 text-gray-600" />
        </button>

        <button className="w-9 h-8 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-50 transition">
          <PiBellSlash className="w-5 h-5 text-gray-600" />
        </button>

        <div className="w-px h-8 bg-gray-300 mx-0.5" />

        <ProfileMenu />

        <button className="w-9 h-8 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-50 transition">
          <PiDotsThree className="w-5 h-5 text-gray-600" />
        </button>
      </div>

      {/* Mobile menu */}
      <div className="md:hidden relative">
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-xl hover:bg-gray-50 transition"
        >
          <PiDotsThree className="w-5 h-5 text-gray-600" />
        </button>

        {isMenuOpen && (
          <>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsMenuOpen(false)}
            />
            <div className="absolute right-0 top-12 z-50 bg-white border-2 border-gray-300 rounded-xl shadow-lg p-2 min-w-[200px]">
              <button
                onClick={() => {
                  setIsModulesOpen(!isModulesOpen);
                  setIsMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition"
              >
                <PiSquaresFour className="w-5 h-5 text-gray-600" />
                <span className="text-sm text-gray-700">Modules</span>
              </button>
              <button className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition">
                <PiEnvelope className="w-5 h-5 text-gray-600" />
                <span className="text-sm text-gray-700">Messages</span>
              </button>
              <button className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition">
                <PiBellSlash className="w-5 h-5 text-gray-600" />
                <span className="text-sm text-gray-700">Notifications</span>
              </button>
              <div className="border-t border-gray-200 my-2" />
              <ProfileMenu />
            </div>
          </>
        )}

        {/* Mobile modules popup */}
        {isModulesOpen && (
          <>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsModulesOpen(false)}
            />
            <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 bg-white border-2 border-gray-200 rounded-2xl shadow-xl p-6 w-[90vw] max-w-[400px]">
              <div className="grid grid-cols-2 gap-4">
                <ModuleButton
                  icon={PiSquaresFour}
                  label="Ingredient Library"
                  size="large"
                />
                <ModuleButton
                  icon={PiSquaresFour}
                  label="Recipe Builder"
                  size="large"
                />
                <ModuleButton
                  icon={PiSquaresFour}
                  label="Product Catalog"
                  size="large"
                />
                <ModuleButton
                  icon={PiSquaresFour}
                  label="Analytics Hub"
                  size="large"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderIcons;
